module.exports = __webpack_public_path__ + "static/media/bg-puzzle-piece.fb6ce71c.png";